import { all } from "axios";
import { remove } from "lodash";

const messages = {
    en: {
        message: {
            locale: 'en',
            pagination: {
                previous: '&laquo; Previous',
                next: 'Next &raquo;',
            },
            login: {
                welcome_back: 'Welcome back!',
                email: 'Email',
                email_title: 'Enter your nafa email',
                password: 'Password',
                show_password: 'Show Password',
                login: 'Login',
                wrong_credentials: 'These credentials do not match our records.',
            },
            dashboard: {
                title: 'Dashboard',
                dashboard_welcome_message: 'Hi {name}!, Welcome to Nafa Support Portal, a system designed to facilitate some of Nafa activities',
            },
            general: {
                all: 'All',
                by: 'by',
                create: 'Create',
                edit: 'Edit',
                delete: 'Delete',
                save: 'Save',
                cancel: 'Cancel',
                close: 'Close',
                update: 'Update',
                actions: 'Actions',
                search: 'Search...',
                no_data: 'No data available',
                no_results: 'No results found',
                confirm_delete: 'Are you sure you want to delete this item?',
                confirm: 'Confirm',
                yes: 'Yes',
                no: 'No',
                success: 'Success',
                error: 'Error',
                warning: 'Warning',
                info: 'Info',
                are_you_sure: 'Are you sure?',
                success_message: 'Operation completed successfully',
                error_message: 'An error occurred while processing your request',
                warning_message: 'Warning: Please check your input',
                info_message: 'Info: Please check the following',
                created_at: 'Created At',
                updated_at: 'Updated At',
                optional: 'Optional',
                search: 'Search...',
                filter: 'Filter',
                trashed: 'Trashed',
                with_trashed: 'With Trashed',
                only_trashed: 'Only Trashed',
                department: 'Department',
                role: 'Role',
                status: 'Status',
                gender: 'Gender',
                male: 'Male',
                female: 'Female',
                phone: 'Phone',
                submit: 'Submit',
                reset: 'Reset',
                remove: 'Remove',
                import: 'Import',
            },
            profile: {
                my_profile: 'My Profile',
                logout: 'Logout',
            },
            menu: {
                dashboard: 'Dashboard',
                tickets: 'Tickets',
                issues: 'Issues',
                staffs: 'Staff',
                nafa_staffs: 'Nafa Staff',
                departments: 'Departments',
                loans: 'Loans',
                loan_types: 'Loan Types',
                agents: 'Agents',
                sub_agents: 'Sub-Agents',
                payout_locations: 'Payout Locations',
                branches: 'Branches',
                leave: 'Leave',
                leave_type: 'Leave Type',
                expenses: 'Expenses',
                expense_requests: 'Expense Requests',
                expense_tickets: 'Expense Tickets',
                reports: 'Reports',
                staffs_report: 'Staff Report',
                tickets_report: 'Tickets Report',
                expense_tickets_report: 'Expense Tickets Report',
            },
            tickets: {
                tickets: 'Ticket | Tickets',
                create_ticket: 'Create Ticket',
                subject: 'Subject',
                created_by: 'Created By',
                issue: 'Issue',
                department: 'Department',
                code: 'Code',
                description: 'Description',
                attachment: 'Attachment (optional)',
                import: 'Import',
                pending: 'Pending',
                resolved: 'Resolved',
                in_progress: 'In Progress',
                closed: 'Closed',
                remove: 'Remove',
                download: 'Download',
                no_tickets_found: 'No tickets found',
                add_attachment: 'Add Attachment',
                delete_ticket: 'Delete Ticket',
                update_ticket: 'Update Ticket',
            },
            issues: {
                issues: 'Issue | Issues',
                create_issue: 'Create Issue',
                name: 'Name',
                description: 'Description',
                delete_issue: 'Delete Issue',
                update_issue: 'Update Issue',
                no_issues_found: 'No issues found',
            },
            staffs: {
                staffs: 'Staff | Staff',
                create_staff: 'Create Staff',
                name: 'Name',
                first_name: 'First Name',
                last_name: 'Last Name',
                email: 'Email',
                password: 'Password',
                nafa_id: 'Nafa ID',
                department: 'Department',
                phone: 'Phone',
                country: 'Country',
                role: 'Role',
                admin: 'Admin',
                executive: 'Executive',
                staff: 'Staff',
                designation: 'Designation',
                date_employed: 'Date Employed',
                delete_staff: 'Delete Staff',
                update_staff: 'Update Staff',
                no_staffs_found: 'No staff found',
                net_salary: 'Net Salary',
                level: 'Level',
                id_number: 'Passport/National ID Number',
                social_security_number: 'Social Security Number',
                tin_number: 'TIN',
                date_of_birth: 'Date of Birth',
                nationality: 'Nationality',
                residential_address: 'Residential Address',
                marital_status: 'Marital Status',
                emergency_contact_name: 'Emergency Contact Name',
                emergency_contact_number: 'Emergency Contact Number',
                single: 'Single',
                married: 'Married',
                divorced: 'Divorced',
                separated: 'Separated',
                widowed: 'Widowed',
            },
            departments: {
                admin: 'Admin',
                departments: 'Department | Departments',
                create_department: 'Create Department',
                head: 'Head',
                supervisor: 'Supervisor',
                parent_department: 'Parent Department',
                delete_department: 'Delete Department',
                update_department: 'Update Department',
                no_departments_found: 'No departments found',
                business_development: 'Business Development',
                customer_service: 'Customer Service',
                compliance: 'Compliance',
                finance: 'Finance',
                human_resources_and_corporate_communications: 'Human Resources & Corporate Communications',
                it: 'I.T.',
                operations: 'Operations',
                mobile_money: 'Mobile Money',
                online_mobile_transfer: 'Online Mobile Transfer',
                marketing: 'Marketing',
                name: 'Name',
                country: 'Country',
                department_head: 'Department Head',
                email: 'Email',
                phone: 'Phone',
            },
            branches: {
                branches: 'Branch | Branches',
                import: 'Import',
                location: 'Location',
                address: 'Address',
                contact: 'Contact',
                mynafa_agent: 'MyNafa Agent',
                mynafa_agents: 'MyNafa Agents',
                payout_locations: 'Payout Locations',
                is_nafa_agent: 'Is MyNafa Agent?',
                delete_branch: 'Delete Branch',
                update_branch: 'Update Branch',
                no_branches_found: 'No branches found',
                branch: 'Branch',
            },
            leave: {
                leave: 'Leave',
                create_leave: 'Create Leave',
                requesting_staff: 'Requesting Staff',
                leave_type: 'Leave Type',
                start_date: 'Leave Start Date',
                num_of_days: 'Number of Days',
                end_date: 'End Date',
                resume_date: 'Resume Date',
                leave_address: 'Leave Address',
                leave_phone: 'Leave Phone',
                leave_email: 'Leave Email',
                leave_note: '*Please note that this leave request must be sent at least 7 Days before the intended leave date.',
                leave_date_of_resuming: 'Date of Resuming:',
                leave_end_date: 'End Date:',
                leave_outsanding_days: 'Outstanding Annual Leave Days:',
                reason: 'Reason',
                created: 'Created',
                pending: 'Pending',
                approved: 'Approved',
                declined: 'Declined',
                finalised: 'Finalised',
                delete_leave: 'Delete Leave',
                update_leave: 'Update Leave',
                edit_leave: 'Edit Leave',
                no_leaves_found: 'No leaves found',
            },
            leave_type: {
                leave_type: 'Leave Type | Leave Types',
                create_leave_type: 'Create Leave Type',
                title: 'Title',
                description: 'Description',
                details: 'Details',
                paternity_leave: 'Paternity Leave',
                maternity_leave: 'Maternity Leave',
                casual_leave: 'Casual Leave',
                compassionate_leave: 'Compassionate Leave',
                annual_leave: 'Annual Leave',
                delete_leave_type: 'Delete Leave Type',
                update_leave_type: 'Update Leave Type',
                no_leave_types_found: 'No leave types found',
            },
            expense_requests: {
                expenses: 'Expense | Expenses',
                expense_requests: 'Expense Request | Expense Requests',
                create_expense_request: 'Create Expense Request',
                edit_expense_request: 'Edit Expense Request',
                name: 'Name',
                title: 'Title',
                requesting_staff: 'Requesting Staff',
                date_created: 'Date Created',
                total: 'Total',
                approved_by: 'Approved By',
                item: 'Item',
                description: 'Description',
                cost: 'Cost',
                cost_per_item: 'Cost (Per Item) in {currency}',
                quantity: 'Quantity',
                sub_total: 'Sub Total',
                add_row: 'Add Row',
                add_item: 'Add Item',
                edit_item: 'Edit Item',
                create_expense: 'Create Expense',
                delete_expense_request: 'Delete Expense',
                update_expense_request: 'Update Expense',
                no_expense_requests_found: 'No expense requests found',
            },
            expense_tickets: {
                expense_tickets: 'Expense Ticket | Expense Tickets',
                create_expense_ticket: 'Create Expense Ticket',
                edit_expense_ticket: 'Edit Expense Ticket',
                title: 'Title',
                prepared_by: 'Prepared By',
                date_created: 'Date Created',
                total: 'Total',
                payment_mode: 'Payment Mode',
                approved_by: 'Approved By',
                expense_line: 'Expense Line',
                in_favor_of: 'In Favor Of (Name)',
                receipt_if_any: 'Receipt (if any)',
                select_image: 'Select Image',
                requested_by: 'Requested By',
                amount_in_words: 'Amount in Words',
                add_row: 'Add Row',
                to_be_received_by: 'To be Received By',
                nafa_code: 'Nafa Code',
                cash: 'Cash',
                cheque: 'Cheque',
                bank_transfer: 'Bank Transfer',
                wallet: 'Wallet',
                bank_name: 'Bank Name',
                account_number: 'Account Number',
                cheque_number: 'Cheque Number',
                wallet_number: 'Wallet Number',
                select_expense: 'Select Expense',
                add_expense: 'Add Expense',
                name: 'Name',
                description: 'Description',
                cost: 'Cost',
                quantity: 'Quantity',
                sub_total: 'Sub Total',
                pending: 'Pending',
                approved: 'Approved',
                rejected: 'Rejected',
                items_in: 'Items in ',
                delete_expense_ticket: 'Delete Expense Ticket',
                update_expense_ticket: 'Update Expense Ticket',
                items_in: 'Items in',
                no_expense_tickets_found: 'No expense tickets found',
            },
            staffs_report: {
                title: 'Staff Report',
                from: 'From',
                to: 'To',
                roles: 'Roles',
                role: 'Role',
                all: 'All',
                admin: 'Admin',
                executive: 'Executive',
                staff: 'Staff',
                departments: 'Departments',
                department: 'Department',
                name: 'Name',
                nafa_id: 'Nafa ID',
                phone: 'Phone',
                email: 'Email',
            },
            tickets_report: {
                title: 'Tickets Report',
                from: 'From',
                to: 'To',
                status: 'Status',
                all: 'All',
                pending: 'Pending',
                resolved: 'Resolved',
                in_progress: 'In Progress',
                closed: 'Closed',
                departments: 'Departments',
                department: 'Department',
                subject: 'Subject',
                created_by: 'Created By',
                issue: 'Issue',
            },
            expense_tickets_report: {
                title: 'Expense Tickets Report',
                num_of_expense_tickets: 'Number of Expense Tickets',
                from: 'From',
                to: 'To',
                status: 'Status',
                all: 'All',
                pending: 'Pending',
                approved: 'Approved',
                rejected: 'Rejected',
                departments: 'Departments',
                department: 'Department',
                title: 'Title',
                prepared_by: 'Prepared By',
                date_created: 'Date Created',
                total: 'Total',
                payment_mode: 'Payment Mode',
                bank_transfer: 'Bank Transfer',
                wallet: 'Wallet',
                cash: 'Cash',
                cheque: 'Cheque',
                approved_by: 'Approved By',
                expense_line: 'Expense Line',
                in_favor_of: 'In Favor Of (Name)',
                receipt_if_any: 'Receipt (if any)',
                requested_by: 'Requested By',
                amount_in_words: 'Amount in Words',
                to_be_received_by: 'To be Received By',
            },
            loan: {
                apply: 'Apply for Loan',
                loan: 'Loan | Loans',
                loan_types: 'Loan Types',
                loan_type: 'Loan Type',
                create_loan_type: 'Create Loan Type',
                edit_loan_type: 'Edit Loan Type',
                name: 'Name',
                interest_rate: 'Interest Rate',
                min_amount: 'Minimum Amount',
                max_amount: 'Maximum Amount',
                no_loan_types_found: 'No loan types found',
                delete_loan_type: 'Delete Loan Type',
                update_loan_type: 'Update Loan Type',
                rejection_reason: 'Rejection Reason',
                create_loan: 'Create Loan',
                edit_loan: 'Edit Loan',
                amount: 'Loan Amount',
                duration: 'Duration (Months)',
                start_date: 'Start Date',
                end_date: 'End Date',
                status: 'Status',
                requesting_staff: 'Requesting Staff',
                approved_by: 'Approved By',
                pending: 'Pending',
                reviewed: 'Reviewed',
                finalised: 'Finalised',
                approved: 'Approved',
                rejected: 'Declined',
                completed: 'Completed',
                delete_loan: 'Delete Loan',
                update_loan: 'Update Loan',
                no_loans_found: 'No loans found',
                monthly_payment: 'Monthly Payment',
                total_payment: 'Total Payment',
                total_interest: 'Total Interest',
                payment_schedule: 'Payment Schedule',
                payment_date: 'Payment Date',
                principal: 'Principal',
                interest: 'Interest',
                balance: 'Balance',
                purpose: 'Purpose',
                payment_summary: 'Payment Summary',
                approval_info: 'Approval Information',
                rejection_info: 'Rejection Information',
                rejected_by: 'Rejected By',
                disbursement_date: 'Disbursement Date',
                this_loan_has_been_deleted: 'This loan has been deleted.',
                outstanding_nafa_loan_balance: 'Outstanding Nafa Loan Balance',
                outstanding_bank_loan_balance: 'Outstanding Bank Loan Balance',
                other_loans_with_nafa: 'Other Loans with Nafa',
                other_loans_with_bank: 'Other Loans with Bank',
                net_salary: 'Net Salary',
                level: 'Level',
                branch: 'Branch',
                wallet_number: 'Wallet Number',
                funds_transfer_status: 'Funds Transfer Status',
                funds_received_at: 'Funds Received At',
                processing: 'Processing',
                failed: 'Failed',
                application_date: 'Application Date',
                finalisation_info: 'Finalisation Info',
                finalised_by: 'Finalised By',
                finalised_at: 'Finalised At',
            }
        }
    },
    fr: {
        message: {
            locale: 'fr',
            pagination: {
                previous: '&laquo; Précédent',
                next: 'Suivant &raquo;',
            },
            login: {
                welcome_back: 'Bienvenue de retour!',
                email: 'Email',
                email_title: 'Entrez votre email nafa',
                password: 'Mot de passe',
                show_password: 'Afficher le mot de passe',
                login: 'S\'identifier',
                wrong_credentials: 'Ces informations d\'identification ne correspondent pas à nos enregistrements.',
            },
            dashboard: {
                title: 'Tableau de bord',
                dashboard_welcome_message: 'Salut {name}!, Bienvenue sur le portail de support Nafa, un système conçu pour faciliter certaines activités de Nafa',
            },
            general: {
                all: 'Tout',
                by: 'par',
                create: 'Créer',
                edit: 'Modifier',
                delete: 'Supprimer',
                save: 'Enregistrer',
                cancel: 'Annuler',
                close: 'Fermer',
                update: 'Mettre à jour',
                actions: 'Actions',
                search: 'Rechercher...',
                no_data: 'Pas de données disponibles',
                no_results: 'Aucun résultat trouvé',
                confirm_delete: 'Êtes-vous sûr de vouloir supprimer cet élément?',
                confirm: 'Confirmer',
                yes: 'Oui',
                no: 'Non',
                success: 'Succès',
                error: 'Erreur',
                warning: 'Avertissement',
                info: 'Info',
                are_you_sure: 'Êtes-vous sûr?',
                success_message: 'Opération terminée avec succès',
                error_message: 'Une erreur s\'est produite lors du traitement de votre demande',
                warning_message: 'Avertissement: Veuillez vérifier votre saisie',
                info_message: 'Info: Veuillez vérifier ce qui suit',
                created_at: 'Créé à',
                updated_at: 'Mis à jour à',
                optional: 'Optionnel',
                search: 'Rechercher...',
                filter: 'Filtrer',
                trashed: 'Poubelle',
                with_trashed: 'Avec poubelle',
                only_trashed: 'Uniquement poubelle',
                department: 'Département',
                role: 'Rôle',
                status: 'Statut',
                gender: 'Genre',
                male: 'Home',
                female: 'Femme',
                phone: 'Téléphone',
                submit: 'Soumettre',
                reset: 'Réinitialiser',
                remove: 'Supprimer',
                import: 'Importer',
            },
            profile: {
                my_profile: 'Mon profil',
                logout: 'Se déconnecter',
            },
            menu: {
                dashboard: 'Tableau de bord',
                tickets: 'Billets',
                issues: 'Problèmes',
                staffs: 'Personnel',
                nafa_staffs: 'Personnel de Nafa',
                departments: 'Départements',
                loans: 'Prêts',
                loan_types: 'Types de prêts',
                agents: 'Agents',
                sub_agents: 'Sous-agents',
                payout_locations: 'Lieux de paiement',
                branches: 'Succursales',
                leave: 'Congé',
                leave_type: 'Type de congé',
                expenses: 'Dépenses',
                expense_requests: 'Demandes de dépenses',
                expense_tickets: 'Billets de dépenses',
                reports: 'Rapports',
                staffs_report: 'Rapport du personnel',
                tickets_report: 'Rapport des billets',
                expense_tickets_report: 'Rapport des tickets de dépenses',
            },
            tickets: {
                tickets: 'Billet | Billets',
                create_ticket: 'Créer un ticket',
                subject: 'Sujet',
                created_by: 'Créé par',
                issue: 'Problème',
                department: 'Département',
                code: 'Code',
                description: 'La description',
                attachment: 'Attachement (optionnel)',
                import: 'Importer',
                pending: 'En attente',
                resolved: 'Résolu',
                in_progress: 'En cours',
                closed: 'Fermé',
                remove: 'Supprimer',
                download: 'Télécharger',
                no_tickets_found: 'Aucun billet trouvé',
                add_attachment: 'Ajouter une pièce jointe',
                delete_ticket: 'Supprimer le ticket',
                update_ticket: 'Mettre à jour le ticket',
            },
            issues: {
                issues: 'Problèm | Problèmes',
                create_issue: 'Créer un problème',
                name: 'Nom',
                description: 'La description',
                delete_issue: 'Supprimer le problème',
                update_issue: 'Mettre à jour le problème',
                no_issues_found: 'Aucun problème trouvé',
            },
            staffs: {
                staffs: 'Personnel | Personnel',
                create_staff: 'Créer un personnel',
                name: 'Nom',
                first_name: 'Prénom',
                last_name: 'Nom de famille',
                email: 'Email',
                password: 'Mot de passe',
                nafa_id: 'Nafa ID',
                department: 'Département',
                phone: 'Téléphone',
                country: 'Pays',
                role: 'Rôle',
                admin: 'Administrateur',
                executive: 'Exécutif',
                staff: 'Personnel',
                designation: 'Désignation',
                date_employed: 'Date Employé',
                delete_staff: 'Supprimer le personnel',
                update_staff: 'Mettre à jour le personnel',
                no_staffs_found: 'Aucun personnel trouvé',
                net_salary: 'Salaire net',
                level: 'Niveau',
                id_number: 'Numéro de passeport/carte d\'identité',
                social_security_number: 'Numéro de sécurité sociale',
                tin_number: 'Numéro TIN',
                date_of_birth: 'Date de naissance',
                nationality: 'Nationalité',
                residential_address: 'Adresse résidentielle',
                marital_status: 'État civil',
                emergency_contact_name: 'Nom du contact d\'urgence',
                emergency_contact_number: 'Numéro du contact d\'urgence',
                single: 'Célibataire',
                married: 'Marié(e)',
                divorced: 'Divorcé(e)',
                separated: 'Séparé(e)',
                widowed: 'Veuf/Veuve',
            },
            departments: {
                admin: 'Admin',
                departments: 'Département | Départements',
                create_department: 'Créer un département',
                head: 'Tête',
                supervisor: 'Superviseur',
                parent_department: 'Département parent',
                delete_department: 'Supprimer le département',
                update_department: 'Mettre à jour le département',
                no_departments_found: 'Aucun département trouvé',
                business_development: 'Développement des affaires',
                customer_service: 'Service client',
                compliance: 'Conformité',
                finance: 'Finance',
                human_resources_and_corporate_communications: 'Ressources humaines et communications d\'entreprise',
                it: 'I.T.',
                operations: 'Opérations',
                mobile_money: 'Mobile Money',
                online_mobile_transfer: 'Online Mobile Transfer',
                marketing: 'Marketing',
                name: 'Nom',
                country: 'Pays',
                department_head: 'Chef de département',
                email: 'Email',
                phone: 'Téléphone',
            },
            branches: {
                branches: 'Succursale | Succursales',
                import: 'Importer',
                location: 'Emplacement',
                address: 'Adresse',
                contact: 'Contact',
                mynafa_agent: 'Agent MyNafa',
                mynafa_agents: 'Agents MyNafa',
                payout_locations: 'Lieux de paiement',
                is_nafa_agent: 'Est-ce que MyNafa Agent?',
                delete_branch: 'Supprimer la succursale',
                update_branch: 'Mettre à jour la succursale',
                no_branches_found: 'Aucune succursale trouvée',
                branch: 'Succursale',
            },
            leave: {
                leave: 'Congé',
                create_leave: 'Créer un congé',
                requesting_staff: 'Personnel demandeur',
                leave_type: 'Type de congé',
                start_date: 'Date de début du congé',
                num_of_days: 'Nombre de jours',
                end_date: 'Date de fin',
                resume_date: 'Date de reprise',
                leave_address: 'Adresse de congé',
                leave_phone: 'Téléphone de congé',
                leave_email: 'Email de congé',
                leave_note: '*Veuillez noter que cette demande de congé doit être envoyée au moins 7 jours avant la date de congé prévue.',
                leave_date_of_resuming: 'Date de reprise:',
                leave_end_date: 'Date de fin:',
                leave_outsanding_days: 'Jours de congé annuel en cours:',
                reason: 'Raison',
                created: 'Créé',
                pending: 'En attente',
                approved: 'Approuvé',
                declined: 'Rejeté',
                finalised: 'Finalisé',
                delete_leave: 'Supprimer le congé',
                update_leave: 'Mettre à jour le congé',
                edit_leave: 'Modifier le congé',
                no_leaves_found: 'Aucun congé trouvé',
            },
            leave_type: {
                leave_type: 'Type de congé',
                create_leave_type: 'Créer un type de congé',
                title: 'Titre',
                description: 'La description',
                details: 'Détails',
                paternity_leave: 'Congé de paternité',
                maternity_leave: 'Congé de maternité',
                casual_leave: 'Congé décontracté',
                compassionate_leave: 'Congé de compassion',
                annual_leave: 'Congé annuel',
                delete_leave_type: 'Supprimer le type de congé',
                update_leave_type: 'Mettre à jour le type de congé',
                no_leave_types_found: 'Aucun type de congé trouvé',
            },
            expense_requests: {
                expenses: 'Dépense | Dépenses',
                expense_requests: 'Demande de dépense | Demandes de dépenses',
                create_expense_request: 'Créer une demande de dépenses',
                edit_expense_request: 'Modifier la demande de dépenses',
                name: 'Nom',
                title: 'Titre',
                requesting_staff: 'Personnel demandeur',
                date_created: 'Date de création',
                total: 'Total',
                approved_by: 'Approuvé par',
                item: 'Article',
                description: 'La description',
                cost: 'Coût',
                cost_per_item: 'Coût (par article) en {currency}',
                quantity: 'Quantité',
                sub_total: 'Sous-total',
                add_item: 'Ajouter un article',
                edit_item: 'Modifier l\'article',
                add_row: 'Ajouter une ligne',
                create_expense: 'Créer une dépense',
                delete_expense_request: 'Supprimer la dépense',
                update_expense_request: 'Mettre à jour la dépense',
                no_expense_requests_found: 'Aucune demande de dépenses trouvée',
            },
            expense_tickets: {
                expense_tickets: 'Billet de dépense | Billets de dépenses',
                create_expense_ticket: 'Créer un ticket de dépenses',
                edit_expense_ticket: 'Modifier le ticket de dépenses',
                title: 'Titre',
                prepared_by: 'Préparé par',
                date_created: 'Date de création',
                total: 'Total',
                payment_mode: 'Mode de paiement',
                approved_by: 'Approuvé par',
                expense_line: 'Ligne de dépenses',
                in_favor_of: 'En faveur de (Nom)',
                receipt_if_any: 'Reçu (le cas échéant)',
                select_image: 'Sélectionner une image',
                requested_by: 'Demandé par',
                amount_in_words: 'Montant en mots',
                add_row: 'Ajouter une ligne',
                to_be_received_by: 'À recevoir par',
                nafa_code: 'Code Nafa',
                cash: 'Espèces',
                cheque: 'Chèque',
                bank_transfer: 'Virement bancaire',
                wallet: 'Portefeuille',
                bank_name: 'Nom de la banque',
                account_number: 'Numéro de compte',
                cheque_number: 'Numéro de chèque',
                wallet_number: 'Numéro de portefeuille',
                select_expense: 'Sélectionner une dépense',
                add_expense: 'Ajouter une dépense',
                name: 'Nom',
                description: 'La description',
                cost: 'Coût',
                quantity: 'Quantité',
                sub_total: 'Sous-total',
                pending: 'En attente',
                approved: 'Approuvé',
                rejected: 'Rejeté',
                items_in: 'Articles en ',
                delete_expense_ticket: 'Supprimer le ticket de dépenses',
                update_expense_ticket: 'Mettre à jour le ticket de dépenses',
                items_in: 'Articles en',
                no_expense_tickets_found: 'Aucun ticket de dépenses trouvé',
            },
            staffs_report: {
                title: 'Rapport du personnel',
                from: 'De',
                to: 'À',
                roles: 'Rôles',
                role: 'Rôle',
                all: 'Tout',
                admin: 'Administrateur',
                executive: 'Exécutif',
                staff: 'Personnel',
                departments: 'Départements',
                department: 'Département',
                name: 'Nom',
                nafa_id: 'Nafa ID',
                phone: 'Téléphone',
                email: 'Email',
            },
            tickets_report: {
                title: 'Rapport des billets',
                from: 'De',
                to: 'À',
                status: 'Statut',
                all: 'Tout',
                pending: 'En attente',
                resolved: 'Résolu',
                in_progress: 'En cours',
                closed: 'Fermé',
                departments: 'Départements',
                department: 'Département',
                subject: 'Sujet',
                created_by: 'Créé par',
                issue: 'Problème',
            },
            expense_tickets_report: {
                title: 'Rapport des tickets de dépenses',
                num_of_expense_tickets: 'Nombre de tickets de dépenses',
                from: 'De',
                to: 'À',
                status: 'Statut',
                all: 'Tout',
                pending: 'En attente',
                approved: 'Approuvé',
                rejected: 'Rejeté',
                departments: 'Départements',
                department: 'Département',
                title: 'Titre',
                prepared_by: 'Préparé par',
                date_created: 'Date de création',
                total: 'Total',
                payment_mode: 'Mode de paiement',
                bank_transfer: 'Virement bancaire',
                wallet: 'Portefeuille',
                cash: 'Espèces',
                cheque: 'Chèque',
                approved_by: 'Approuvé par',
                expense_line: 'Ligne de dépenses',
                in_favor_of: 'En faveur de (Nom)',
                receipt_if_any: 'Reçu (le cas échéant)',
                requested_by: 'Demandé par',
                amount_in_words: 'Montant en mots',
                to_be_received_by: 'À recevoir par',
            },
            loan: {
                apply: 'Appliquer pour un prêt',
                loan: 'Prêt | Prêts',
                loan_types: 'Types de prêts',
                loan_type: 'Type de prêt',
                create_loan_type: 'Créer un type de prêt',
                edit_loan_type: 'Modifier le type de prêt',
                name: 'Nom',
                interest_rate: 'Taux d\'intérêt',
                min_amount: 'Montant minimum',
                max_amount: 'Montant maximum',
                no_loan_types_found: 'Aucun type de prêt trouvé',
                delete_loan_type: 'Supprimer le type de prêt',
                update_loan_type: 'Mettre à jour le type de prêt',
                rejection_reason: 'Raison de rejet',
                create_loan: 'Créer un prêt',
                edit_loan: 'Modifier le prêt',
                amount: 'Montant du prêt',
                duration: 'Durée (Mois)',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                status: 'Statut',
                requesting_staff: 'Personnel demandeur',
                approved_by: 'Approuvé par',
                pending: 'En attente',
                reviewed: 'Revu',
                finalised: 'Finalisé',
                approved: 'Approuvé',
                rejected: 'Rejeté',
                completed: 'Terminé',
                delete_loan: 'Supprimer le prêt',
                update_loan: 'Mettre à jour le prêt',
                no_loans_found: 'Aucun prêt trouvé',
                monthly_payment: 'Paiement mensuel',
                total_payment: 'Paiement total',
                total_interest: 'Intérêt total',
                payment_schedule: 'Calendrier de paiement',
                payment_date: 'Date de paiement',
                principal: 'Principal',
                interest: 'Intérêt',
                balance: 'Solde',
                purpose: 'Objectif',
                payment_summary: 'Résumé du paiement',
                approval_info: 'Informations d\'approbation',
                rejection_info: 'Informations de rejet',
                rejected_by: 'Rejeté par',
                disbursement_date: 'Date de décaissement',
                this_loan_has_been_deleted: 'Ce prêt a été supprimé.',
                outstanding_nafa_loan_balance: 'Solde impayé du prêt Nafa',
                outstanding_bank_loan_balance: 'Solde impayé du prêt bancaire',
                other_loans_with_nafa: 'Autres prêts avec Nafa',
                other_loans_with_bank: 'Autres prêts avec la banque',
                net_salary: 'Salaire net',
                level: 'Niveau',
                branch: 'Succursale',
                wallet_number: 'Numéro de portefeuille',
                funds_transfer_status: 'Statut du transfert de fonds',
                funds_received_at: 'Fonds reçus à',
                processing: 'En cours de traitement',
                failed: 'Échoué',
                application_date: 'Date de demande',
                finalisation_info: 'Informations de finalisation',
                finalised_by: 'Finalisé par',
                finalised_at: 'Finalisé à',
            }
        }
    },
    ar: {
        message: {
            locale: 'ar',
            pagination: {
                previous: 'السابق &laquo;',
                next: '&raquo; التالي',
            },
            login: {
                welcome_back: 'مرحبًا بعودتك!',
                email: 'البريد الإلكتروني',
                email_title: 'أدخل بريدك الإلكتروني في نافا',
                password: 'كلمة المرور',
                show_password: 'إظهار كلمة المرور',
                login: 'تسجيل الدخول',
                wrong_credentials: 'بيانات الاعتماد هذه لا تتطابق مع سجلاتنا.',
            },
            dashboard: {
                title: 'لوحة التحكم',
                dashboard_welcome_message: 'مرحبًا {name}، مرحبًا بك في بوابة دعم نافا، وهو نظام مصمم لتسهيل بعض أنشطة نافا',
            },
            general: {
                all: 'الكل',
                by: 'بواسطة',
                create: 'إنشاء',
                edit: 'تعديل',
                delete: 'حذف',
                save: 'حفظ',
                cancel: 'إلغاء',
                close: 'إغلاق',
                update: 'تحديث',
                actions: 'إجراءات',
                search: 'بحث...',
                no_data: 'لا توجد بيانات متاحة',
                no_results: 'لم يتم العثور على نتائج',
                confirm_delete: 'هل أنت متأكد أنك تريد حذف هذا العنصر؟',
                confirm: 'تأكيد',
                yes: 'نعم',
                no: 'لا',
                success: 'نجاح',
                error: 'خطأ',
                warning: 'تحذير',
                info: 'معلومات',
                are_you_sure: 'هل أنت متأكد؟',
                success_message: 'تمت العملية بنجاح',
                error_message: 'حدث خطأ أثناء معالجة طلبك',
                warning_message: 'تحذير: يرجى التحقق من المدخلات الخاصة بك',
                info_message: 'معلومات: يرجى التحقق مما يلي',
                created_at: 'تم الإنشاء في',
                updated_at: 'تم التحديث في',
                optional: 'اختياري',
                search: 'بحث...',
                filter: 'تصفية',
                trashed: 'المحذوفات',
                with_trashed: 'مع المحذوفات',
                only_trashed: 'المحذوفات فقط',
                department: 'القسم',
                role: 'الدور',
                status: 'الحالة',
                gender: 'الجنس',
                male: 'ذكر',
                female: 'أنثى',
                phone: 'الهاتف',
                submit: 'إرسال',
                reset: 'إعادة تعيين',
                remove: 'إزالة',
                import: 'استيراد',
            },
            profile: {
                my_profile: 'ملفي الشخصي',
                logout: 'تسجيل الخروج',
            },
            menu: {
                dashboard: 'لوحة التحكم',
                tickets: 'التذاكر',
                issues: 'المشاكل',
                staffs: 'الموظفين',
                nafa_staffs: 'موظفي نافا',
                departments: 'الأقسام',
                loans: 'القروض',
                loan_types: 'أنواع القروض',
                agents: 'الوكلاء',
                sub_agents: 'الوكلاء الفرعيين',
                payout_locations: 'مواقع الدفع',
                branches: 'الفروع',
                leave: 'الإجازات',
                leave_type: 'نوع الإجازة',
                expenses: 'المصروفات',
                expense_requests: 'طلبات المصروفات',
                expense_tickets: 'تذاكر المصروفات',
                reports: 'التقارير',
                staffs_report: 'تقرير الموظفين',
                tickets_report: 'تقرير التذاكر',
                expense_tickets_report: 'تقرير تذاكر المصروفات',
            },
            tickets: {
                tickets: 'تذكر | التذاكر',
                create_ticket: 'إنشاء تذكر',
                subject: 'الموضوع',
                created_by: 'إنشاء بواسطة',
                issue: 'المشكلة',
                department: 'القسم',
                code: 'الرمز',
                description: 'الوصف',
                attachment: 'الإرفاق (اختياري)',
                import: 'استيراد',
                pending: 'قيد الانتظار',
                resolved: 'محلل',
                in_progress: 'في التقدم',
                closed: 'مغلق',
                remove: 'إزالة',
                download: 'تحميل',
                no_tickets_found: 'لم تتم العثور على تذاكر',
                add_attachment: 'إضافة إرفاق',
                delete_ticket: 'إزالة التذكر',
                update_ticket: 'تحديث التذكر',
            },
            issues: {
                issues: 'مشكلة | المشاكل',
                create_issue: 'إنشاء مشكلة',
                name: 'الاسم',
                description: 'الوصف',
                delete_issue: 'إزالة المشكلة',
                update_issue: 'تحديث المشكلة',
                no_issues_found: 'لم تتم العثور على مشاكل',
            },
            staffs: {
                staffs: 'الموظف | الموظفون',
                create_staff: 'إنشاء موظف',
                name: 'الاسم',
                first_name: 'الاسم الأول',
                last_name: 'اسم العائلة',
                email: 'البريد الإلكتروني',
                password: 'كلمة المرور',
                nafa_id: 'معرف نافا',
                department: 'القسم',
                phone: 'الهاتف',
                country: 'البلد',
                role: 'الدور',
                admin: 'المسؤول',
                executive: 'الإداري',
                staff: 'الموظف',
                designation: 'التصنيف',
                date_employed: 'تاريخ التعيين',
                delete_staff: 'إزالة الموظف',
                update_staff: 'تحديث الموظف',
                no_staffs_found: 'لم تتم العثور على موظفون',
                net_salary: 'الراتب الصافي',
                level: 'المستوى',
                id_number: 'رقم بطاقة هوية السفر/رقم الهوية الوطنية',
                social_security_number: 'رقم الأمان الاجتماعي',
                tin_number: 'رقم TIN',
                date_of_birth: 'تاريخ الميلاد',
                nationality: 'جنسية',
                residential_address: 'العنوان السكني',
                marital_status: 'الحالة المدنية',
                emergency_contact_name: 'اسم اتصال الطوارئ',
                emergency_contact_number: 'رقم اتصال الطوارئ',
                single: 'أعزب',
                married: 'متزوج/متزوجة',
                divorced: 'مطلق/مطلقة',
                separated: 'مفصول/مفصولة',
                widowed: 'أرمل/أرملة',
            },
            departments: {
                admin: 'المسؤول',
                departments: 'القسم | الأقسام',
                create_department: 'إنشاء قسم',
                head: 'الرأس',
                supervisor: 'المشرف',
                parent_department: 'القسم الأب',
                delete_department: 'إزالة القسم',
                update_department: 'تحديث القسم',
                no_departments_found: 'لم تتم العثور على أقسام',
                business_development: 'تطوير الأعمال',
                customer_service: 'خدمة العملاء',
                compliance: 'الامتثال',
                finance: 'المالية',
                human_resources_and_corporate_communications: 'موارد الإنسان والاتصالات المهنية',
                it: 'إِت',
                operations: 'العمليات',
                mobile_money: 'المال الموبايل',
                online_mobile_transfer: 'التحويل الموبايل عبر الإنترنت',
                marketing: 'التسويق',
                name: 'الاسم',
                country: 'البلد',
                department_head: 'رئيس القسم',
                email: 'البريد الإلكتروني',
                phone: 'الهاتف',
            },
            branches: {
                branches: 'الفرع | الفروع',
                import: 'استيراد',
                location: 'الموقع',
                address: 'العنوان',
                contact: 'الاتصال',
                mynafa_agent: 'وكيل MyNafa',
                mynafa_agents: 'وكلاء MyNafa',
                payout_locations: 'مواقع الدفع',
                is_nafa_agent: 'هل وكيل MyNafa؟',
                delete_branch: 'إزالة الفرع',
                update_branch: 'تحديث الفرع',
                no_branches_found: 'لم تتم العثور على أفرع',
                branch: 'الفرع',
            },
            leave: {
                leave: 'الإجازة',
                create_leave: 'إنشاء إجازة',
                requesting_staff: 'الموظف المتقدم',
                leave_type: 'نوع الإجازة',
                start_date: 'تاريخ بدء الإجازة',
                num_of_days: 'عدد الأيام',
                end_date: 'تاريخ الانتهاء',
                resume_date: 'تاريخ الاستئناف',
                leave_address: 'عنوان الإجازة',
                leave_phone: 'هاتف الإجازة',
                leave_email: 'بريد الإجازة',
                leave_note: '*يرجى ملاحظة أن طلب الإجازة يجب إرساله في وقت عدم المساعدة لمدة 7 أيام على الأقل قبل تاريخ الإجازة المقرر.',
                leave_date_of_resuming: 'تاريخ الاستئناف:',
                leave_end_date: 'تاريخ الانتهاء:',
                leave_outsanding_days: 'أيام الإجازة السنوية المستحقة:',
                reason: 'السبب',
                created: 'إنشاء',
                pending: 'قيد الانتظار',
                approved: 'موافق',
                declined: 'مرفوض',
                finalised: 'منتهي',
                delete_leave: 'إزالة الإجازة',
                update_leave: 'تحديث الإجازة',
                edit_leave: 'تحرير الإجازة',
                no_leaves_found: 'لم تتم العثور على إجازات',
            },
            leave_type: {
                leave_type: 'نوع الإجازة',
                create_leave_type: 'إنشاء نوع إجازة',
                title: 'العنوان',
                description: 'الوصف',
                details: 'التفاصيل',
                paternity_leave: 'إجازة أبوية',
                maternity_leave: 'إجازة مولدية',
                casual_leave: 'إجازة عشوائية',
                compassionate_leave: 'إجازة عطفية',
                annual_leave: 'إجازة سنوية',
                delete_leave_type: 'إزالة نوع الإجازة',
                update_leave_type: 'تحديث نوع الإجازة',
                no_leave_types_found: 'لم تتم العثور على أنواع إجازة',
            },
            expense_requests: {
                expenses: 'مصروف | المصروفات',
                expense_requests: 'طلب مصروف | طلبات المصروفات',
                create_expense_request: 'إنشاء طلب مصروف',
                edit_expense_request: 'تحرير طلب المصروف',
                name: 'الاسم',
                title: 'العنوان',
                requesting_staff: 'الموظف المتقدم',
                date_created: 'تاريخ الإنشاء',
                total: 'المجموع',
                approved_by: 'موافق بواسطة',
                item: 'الصنف',
                description: 'الوصف',
                cost: 'التكلفة',
                cost_per_item: 'التكلفة (لكل صنف) بالعملة {currency}',
                quantity: 'الكمية',
                sub_total: 'المجموع الفرعي',
                add_item: 'إضافة صنف',
                edit_item: 'تحرير الصنف',
                add_row: 'إضافة صف',
                create_expense: 'إنشاء مصروف',
                delete_expense_request: 'إزالة المصروف',
                update_expense_request: 'تحديث المصروف',
                no_expense_requests_found: 'لم تتم العثور على طلبات مصروف',
            },
            expense_tickets: {
                expense_tickets: 'تذكر مصروف | تذاكر المصروفات',
                create_expense_ticket: 'إنشاء تذكر مصروف',
                edit_expense_ticket: 'تحرير تذكر مصروف',
                title: 'العنوان',
                prepared_by: 'مستعد بواسطة',
                date_created: 'تاريخ الإنشاء',
                total: 'المجموع',
                payment_mode: 'وسيلة الدفع',
                approved_by: 'موافق بواسطة',
                expense_line: 'خط مصروف',
                in_favor_of: 'في مكان الصنف (الاسم)',
                receipt_if_any: 'الإستلام (إن وجد)',
                select_image: 'اختيار الصورة',
                requested_by: 'طلب بواسطة',
                amount_in_words: 'مبلغ بالكلمات',
                add_row: 'إضافة صف',
                to_be_received_by: 'إلى الاستلام بواسطة',
                nafa_code: 'رمز نافا',
                cash: 'نقدي',
                cheque: 'شيك',
                bank_transfer: 'تحويل بنكي',
                wallet: 'محفظة',
                bank_name: 'اسم البنك',
                account_number: 'رقم الحساب',
                cheque_number: 'رقم الشيك',
                wallet_number: 'رقم محفظة',
                select_expense: 'اختيار مصروف',
                add_expense: 'إضافة مصروف',
                name: 'الاسم',
                description: 'الوصف',
                cost: 'التكلفة',
                quantity: 'الكمية',
                sub_total: 'المجموع الفرعي',
                pending: 'قيد الانتظار',
                approved: 'موافق',
                rejected: 'مرفوض',
                items_in: 'الصنف في ',
                delete_expense_ticket: 'إزالة تذكر مصروف',
                update_expense_ticket: 'تحديث تذكر مصروف',
                items_in: 'الصنف في',
                no_expense_tickets_found: 'لم تتم العثور على تذاكر مصروف',
            },
            staffs_report: {
                title: 'تقرير الموظفين',
                from: 'من',
                to: 'إلى',
                roles: 'الأدوار',
                role: 'الدور',
                all: 'الكل',
                admin: 'المسؤول',
                executive: 'الإداري',
                staff: 'الموظف',
                departments: 'الأقسام',
                department: 'القسم',
                name: 'الاسم',
                nafa_id: 'معرف نافا',
                phone: 'الهاتف',
                email: 'البريد الإلكتروني',
            },
            tickets_report: {
                title: 'تقرير التذاكر',
                from: 'من',
                to: 'إلى',
                status: 'الحالة',
                all: 'الكل',
                pending: 'قيد الانتظار',
                resolved: 'محلل',
                in_progress: 'في التقدم',
                closed: 'مغلق',
                departments: 'الأقسام',
                department: 'القسم',
                subject: 'الموضوع',
                created_by: 'إنشاء بواسطة',
                issue: 'المشكلة',
            },
            expense_tickets_report: {
                title: 'تقرير تذاكر المصروفات',
                num_of_expense_tickets: 'عدد تذاكر المصروفات',
                from: 'من',
                to: 'إلى',
                status: 'الحالة',
                all: 'الكل',
                pending: 'قيد الانتظار',
                approved: 'موافق',
                rejected: 'مرفوض',
                departments: 'الأقسام',
                department: 'القسم',
                title: 'العنوان',
                prepared_by: 'مستعد بواسطة',
                date_created: 'تاريخ الإنشاء',
                total: 'المجموع',
                payment_mode: 'وسيلة الدفع',
                bank_transfer: 'تحويل بنكي',
                wallet: 'محفظة',
                cash: 'نقدي',
                cheque: 'شيك',
                approved_by: 'موافق بواسطة',
                expense_line: 'خط مصروف',
                in_favor_of: 'في مكان الصنف (الاسم)',
                receipt_if_any: 'الإستلام (إن وجد)',
                requested_by: 'طلب بواسطة',
                amount_in_words: 'مبلغ بالكلمات',
                to_be_received_by: 'إلى الاستلام بواسطة',
            },
            loan: {
                apply: 'التقدم بطلب قرض',
                loan: 'قرض | القروض',
                loan_types: 'أنواع القروض',
                loan_type: 'نوع القرض',
                create_loan_type: 'إنشاء نوع قرض',
                edit_loan_type: 'تعديل نوع القرض',
                name: 'الاسم',
                interest_rate: 'معدل الفائدة',
                min_amount: 'الحد الأدنى للمبلغ',
                max_amount: 'الحد الأقصى للمبلغ',
                no_loan_types_found: 'لم تتم العثور على أنواع قروض',
                delete_loan_type: 'إزالة نوع القرض',
                update_loan_type: 'تحديث نوع القرض',
                rejection_reason: 'سبب الرفض',
                create_loan: 'إنشاء قرض',
                edit_loan: 'تعديل القرض',
                amount: 'مبلغ القرض',
                duration: 'المدة (بالشهور)',
                start_date: 'تاريخ البدء',
                end_date: 'تاريخ الانتهاء',
                status: 'الحالة',
                requesting_staff: 'الموظف المتقدم',
                approved_by: 'تمت الموافقة بواسطة',
                pending: 'قيد الانتظار',
                reviewed: 'تمت المراجعة',
                finalised: 'تم الانتهاء',
                approved: 'تمت الموافقة',
                rejected: 'مرفوض',
                completed: 'مكتمل',
                delete_loan: 'إزالة القرض',
                update_loan: 'تحديث القرض',
                no_loans_found: 'لم تتم العثور على قروض',
                monthly_payment: 'الدفع الشهري',
                total_payment: 'إجمالي الدفع',
                total_interest: 'إجمالي الفائدة',
                payment_schedule: 'جدول الدفع',
                payment_date: 'تاريخ الدفع',
                principal: 'المبلغ الأساسي',
                interest: 'الفائدة',
                balance: 'الرصيد',
                purpose: 'الغرض',
                payment_summary: 'ملخص الدفع',
                approval_info: 'معلومات الموافقة',
                rejection_info: 'معلومات الرفض',
                rejected_by: 'مرفوض بواسطة',
                disbursement_date: 'تاريخ الصرف',
                this_loan_has_been_deleted: 'تم حذف هذا القرض.',
                outstanding_nafa_loan_balance: 'رصيد قرض نافا المستحق',
                outstanding_bank_loan_balance: 'رصيد القرض المصرفي المستحق',
                other_loans_with_nafa: 'قروض أخرى مع نافا',
                other_loans_with_bank: 'قروض أخرى مع البنك',
                net_salary: 'صافي الراتب',
                level: 'المستوى',
                branch: 'الفرع',
                wallet_number: 'رقم المحفظة',
                funds_transfer_status: 'حالة تحويل الأموال',
                funds_received_at: 'تم استلام الأموال في',
                processing: 'قيد المعالجة',
                failed: 'فشل',
                application_date: 'تاريخ التقديم',
                finalisation_info: 'معلومات الانتهاء',
                finalised_by: 'منتهي بواسطة',
                finalised_at: 'منتهي في',
            }
        }
    }
}

export default messages;